import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/router'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    curApp:null,
    curLanguage:'it',
    curModel:'DEFAULT',
    curLabelGroup: 'Main Window',
    configurationParameters:[],
    countryList: [],
    carModelList: [],
    labelGroupList: [],
    interfaceLabels:[],
    optColorLabels:[],
    apiJsonTest:[],
    searchLanguageList:[],
    interfaceConfigs:[],
    imgRoot: '/ccb/public/api/imageMapper/',
    currentUi_spinner: 'warning',
    ui_spinnerClasses:[
      {name:'warning', class: 'spinner-border text-warning'},
      {name:'success', class: 'spinner-border text-success'},
      {name:'info', class: 'spinner-border text-info'},      
      {name:'danger', class: 'spinner-border text-danger'},
      {name:'secondary', class: 'spinner-border text-secondary'},
      {name:'dark', class: 'spinner-border text-dark'}
    ],
    spinnerStatus: false,
    optGridGroupList: [],
    optGridLabels:[],
    editorialContents: [],
    editorialPlaceholders:[],
    callToActionList:[],
    optGroupListAdm: [],
    groupTypeList: ["OPT","ACC","CUSTPRG"],
    lastSearch:null,
    languages:[     
      {value:'it', text:'Italiano'},     
    ],
    currentModelId: 'DEFAULT',
    fullModelList:[],
    models:[],
    menuList: [],
    loginSuccess: false,
    loginError: false,
    user: null,
    accessToken: null,
    tokenType: null,
    uploadCsvJSON:null,
    startFromSolModel: false,
    startFromSolCampaign: false,
    startFromPriceConf: false,

    comeFromSolModel: false,
    comeFromSolCampaign: false,
    comeFromPriceConf: false,

    backFromSolModel: false,
    backFromSolCampaign: false,
    backFromPriceConf: false,
    originalCampaignObject: null,
    originalSolModelObject:null,
    baseUrl: 'test',
    solServiceActive: false
  },
  mutations: {
    login_success(state, payload){
      state.loginSuccess = true;
      state.loginError = false;
      payload.user.countries.sort(function(a,b){
        return (a.description < b.description) ? -1 : ((a.description > b.description) ? 1 : 0)
      })
      state.user = payload.user;

      state.accessToken = payload.accessToken;
      state.tokenType = payload.tokenType;
      localStorage.setItem('user', JSON.stringify(payload.user));
      localStorage.setItem('accessToken', JSON.stringify(payload.accessToken));
      localStorage.setItem('tokenType', JSON.stringify(payload.tokenType));
      state.currentUi_spinner = 'info'
    },
    login_error(state, payload){
      state.loginError = true;
      state.loginSuccess = false;
      state.user = payload;
      state.accessToken = null;
      state.tokenType = null;
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('tokenType');
    },
    logout(state){
      state.loginError = false;
      state.loginSuccess = false;
      state.user = null;
      state.accessToken = null;
      state.tokenType = null;
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('tokenType');
      router.push("/")
    },
    setCurrentUi_spinner: (state, value) => {
      state.currentUi_spinner = value
    },
    setSpinnerStatus: (state, value) => {
      state.spinnerStatus = value
    },
    setCurrentModelId: (state, value) => {
      state.currentModelId = value
    },
    setFullModelList: (state, value) => {
      state.fullModelList = value
      localStorage.setItem('fullModelList', JSON.stringify(value));
    },
    setLastSearch: (state, value) => {
      state.lastSearch = value
    },
    setMenuList: (state, value) => {      
      /*var sortMenus = function (menuList) {
        menuList.sort(function(a,b){
            if (a.description < b.description ) {
                return -1;
              }
              if (a.description > b.description) {
                return 1;
              }
              // a deve essere uguale a b
              return 0;
            })
      }
    
      sortMenus(value.submenuList);
      var x = 0;
      while(x < value.submenuList.length){ 

        sortMenus(value.submenuList[x].submenuList)
        x++ ;
      } */
      
      state.menuList = value 
       
      },    
    setLanguageList: (state, obj) => { 
      let langObj = [];
      obj.forEach((e)=>{    
        langObj.push(
          {
            id: e.id, value:e.code, text: e.description, active:e.active, 
            fallbackLanguage: e.fallbackLanguage, language2CharCode: e.language2CharCode,
            languageSimpleCode: e.languageSimpleCode, default: e.default});
        
        });
      state.languages = langObj 
    },
    setEditorialPlaceholders: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.editorialPlaceholders = intLabObj 
    },
    setEditorialContents: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.editorialContents = intLabObj 
    },
    setConfigurationParameters: (state, obj) => {
      state.configurationParameters = obj
    },    
    setCarModelList: (state, obj) => {
      state.carModelList = obj
    },
    setCountryList: (state, obj) => {
      state.countryList = obj
    }, 
    setCallToActionList: (state, obj) => {
      state.callToActionList = obj
    },
     setOptGroupListAdm: (state, obj) => {
      state.optGroupListAdm = obj
    },     
    setGroupTypeList: (state, obj) => {
      state.groupTypeList = obj
    },     
    setInterfaceLabels: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.interfaceLabels = intLabObj 
    },  
    setInterfaceConfigs: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.interfaceConfigs = intLabObj 
    },  
    
    setSearchLanguageList: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.searchLanguageList = intLabObj 
    }, 
    setOptColorLabels: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.optColorLabels = intLabObj 
    },
    setApiJsonTest: (state, obj) => { 
      let intLabObj = [];
      obj.forEach((e)=>{
        intLabObj.push(e);
        
        });
      state.apiJsonTest = intLabObj 
    },
    setEditorialContentList : (state, obj) => { 
      let edCntObj = [];
      obj.forEach((e)=>{
        edCntObj.push({id:e.id, code:e.code, label: e.label, content: e.content, language: e.language, disabled_models: e.modelDisableRegexp, enabled_models: e.modelEnableRegexp});
        
        });
      state.interfaceLabels = intLabObj 
    },
    setLabelGroupList: (state, menSrc) => { 
      var men = null;
      if (menSrc) men = vue_app.findElementByDescription(menSrc, 'Interface Labels')
      var labGroupList = [];
      if (men && men.submenuList ) {
        men.submenuList.forEach(e => {
          labGroupList.push(e.description);
        })
      }
      state.labelGroupList = labGroupList 
    },
    setCurLanguage: (state, el) => state.curLanguage = el,
    setCurModel: (state, el) => state.curModel = el,
    setCurLabelGroup: (state, el) => state.curLabelGroup = el,
    setCurApp: (state, el) => state.curApp = el ,
    setImgRoot: (state, el) => state.imgRoot = el,
    setUploadCsvJSON: (state, el) => state.uploadCsvJSON = el,
    setStartFromSolModel: (state, value) => {
      state.startFromSolModel = value
    },
    setStartFromSolCampaign: (state, value) => {
      state.startFromSolCampaign = value
    },
    setStartFromPriceConf: (state, value) => {
      state.startFromPriceConf = value
    },
    setComeFromSolModel: (state, value) => {
      state.comeFromSolModel = value
    },
    setComeFromSolCampaign: (state, value) => {
      state.comeFromSolCampaign = value
    },
    setComeFromPriceConf: (state, value) => {
      state.comeFromPriceConf = value
    },
    setBackFromSolModel: (state, value) => {
      state.backFromSolModel = value
    },
    setBackFromSolCampaign: (state, value) => {
      state.backFromSolCampaign = value
    },
    setBackFromPriceConf: (state, value) => {
      state.backFromPriceConf = value
    },
    setOriginalCampaignObject: (state, value) => {
      state.originalCampaignObject = value
    },
    setOriginalSolModelObject: (state, value) => {
      state.originalSolModelObject = value
    },
    setBaseUrl: (state, value) => {
      state.baseUrl = value
    },
	  setSolServiceActive: (state, value) => {
      state.solServiceActive = value					   
    },
    updateCountry(state, updatedCountry) {
      const idx = state.user.countries.findIndex(c => c.id === updatedCountry.id)
      if (idx !== -1) {
        state.user.countries.splice(idx, 1, updatedCountry)
      }
    },
    updateCountryVat(state, { countryId, automaticVat }) {
      const c = state.user.countries.find(c => c.id === countryId)
      if (c) c.automaticVat = automaticVat
    },
  },
  actions: {
    setConfigurationParameters({commit},el){
      commit('setConfigurationParameters',el)
    },
    setCarModelList({commit},el){
      commit('setCarModelList',el)
    },
    setCountryList({commit},el){
      commit('setCountryList',el)
    },
    setCurLanguage({ commit }, el) {
      commit('setCurLanguage', el)
    },
    setCurrentUi_spinner: ({commit}, el) => {
      commit('setCurrentUi_spinner', el)
    },
    setSpinnerStatus: ({commit}, el) => {
      commit('setSpinnerStatus', el)
    },    
    setCurrentModelId: ({ commit }, el) => {
      commit('setCurrentModelId', el)
    },
    setFullModelList: ({ commit }, el) => {
      commit('setFullModelList', el)
    },
    setLastSearch: ({ commit }, el) => {
      commit('setLastSearch', el)
    },
    setCallToActionList({commit},el){
      commit('setCallToActionList',el)
    },
    setOptGroupListAdm({commit},el){
      commit('setOptGroupListAdm',el)
    },
    setGroupTypeList({commit},el){
      commit('setGroupTypeList',el)
    },    
    setCurModel({ commit }, el) {
      commit('setCurModel', el)
    },
    setCurLabelGroup({ commit }, el) {
      commit('setCurLabelGroup', el)
    },
    setImgRoot({ commit }, el) {
      commit('setImgRoot', el)
    },   
    setCurApp({ commit }, el) {
      commit('setCurApp', el)
    },
    setUploadCsvJSON({ commit }, el) {
      commit('setUploadCsvJSON', el)
    },
    setInterfaceLabels({ commit }, el) {
      commit('setInterfaceLabels', el)
    },
    setInterfaceConfigs({ commit }, el) {
      commit('setInterfaceConfigs', el)
    },   
    setSearchLanguageList({ commit }, el) {
      commit('setSearchLanguageList', el)
    },   
    setOptColorLabels({ commit }, el) {
      commit('setOptColorLabels', el)
    },
    setApiJsonTest({ commit }, el) {
      commit('setApiJsonTest', el)
    },
     setEditorialPlaceholders({ commit }, el) {
      commit('setEditorialPlaceholders', el)
    },  
    setEditorialContents({ commit }, el) {
      commit('setEditorialContents', el)
    },  
    setLabelGroupList({ commit }, el) {
      commit('setLabelGroupList', el)
    },
    setMenuList({ commit }, obj) {
      commit('setMenuList', obj)
    },
    setLanguageList({ commit }, obj) {
      commit('setLanguageList', obj)
    },
    login_success({ commit }, obj) {
      commit('login_success', obj)
    },
    login_error({ commit }, obj) {
      commit('login_error', obj)
    },
    logout({ commit }) {
      commit('logout')
    },
    setStartFromSolModel: ({commit},el) => {
      commit('setStartFromSolModel',el)
    },
    setStartFromSolCampaign: ({commit},el) => {
      commit('setStartFromSolCampaign',el)
    },
    setStartFromPriceConf: ({commit},el) => {
      commit('setStartFromPriceConf',el)
    },
    setComeFromSolModel: ({commit},el) => {
      commit('setComeFromSolModel',el)
    },
    setComeFromSolCampaign: ({commit},el) => {
      commit('setComeFromSolCampaign',el)
    },
    setComeFromPriceConf: ({commit},el) => {
      commit('setComeFromPriceConf',el)
    },
    setBackFromSolModel: ({commit},el) => {
      commit('setBackFromSolModel',el)
    },
    setBackFromSolCampaign: ({commit},el) => {
      commit('setBackFromSolCampaign',el)
    },
    setBackFromPriceConf: ({commit},el) => {
      commit('setBackFromPriceConf',el)
    },
    setOriginalCampaignObject: ({commit},el) => {
      commit('setOriginalCampaignObject',el)
    },
    setOriginalSolModelObject: ({commit},el) => {
      commit('setOriginalSolModelObject',el)
    },
    setBaseUrl: ({commit},el) => {
      commit('setBaseUrl',el)						   
    },
    setSolServiceActive: ({commit},el) => {
      commit('setSolServiceActive',el)
    }
  },
  getters: {
    getOriginalCampaignObject: state => {
      return state.originalCampaignObject 
    },
    getOriginalSolModelObject: state => {
      return state.originalSolModelObject 
    },
    getCurModel7DigitsCode: state => {
      return state.currentModelId
    },
    getCurModel: state => {
      return state.curModel
    }, 
    getCurrentUi_spinner: state =>{
      return state.currentUi_spinner
    },
    getUi_spinnerClasses: state =>{
      return state.ui_spinnerClasses
    },
    getSpinnerStatus: state =>{
      return state.spinnerStatus
    },
    getCurrentUi_spinnerClass: state =>{
      var currUi_spinner = state.ui_spinnerClasses[0]
      if(window.vue_app) {
        var targ = state.currentUi_spinner
        var src = state.ui_spinnerClasses
        var currUi_spinner = window.vue_app.findElementByName(src, targ)
      }
      
      return currUi_spinner;       
    },
    getCurUser: state => {
      return state.user
    },
    getCountries: state => {
      return state.user.countries
    },
    hasCountries: state => {
      return (state.user && state.user.countries.length) ? true : false
    },
     getCurLabelGroup: state => {
      return state.curLabelGroup
    },
     getImgRoot: state => {
      return state.imgRoot
    },    
    getLanguageList: state => {
      return state.languages
    },
    getCallToActionList: state => {
      return state.callToActionList
    },
    getCurrentModelId: state =>{
      return state.currentModelId;
    },
    getFullModelList: state =>{
      return state.fullModelList;
    },
    getLastSearch: state =>{
      return state.lastSearch;
    },
    getOptGroupListAdm: state => {
      return state.optGroupListAdm
    },
    getGroupTypeList: state => {
      return state.groupTypeList
    },   
    getLanguageLabel: state => {
      return state.languages.find(el => el.value == state.curLanguage).text
    },
    getConfigurationParameters: state => {
      return state.configurationParameters
    },
    getCarModelList: state => {
      return state.carModelList
    },    
    getCountryList: state => {
      return state.countryList
    },
    getCurLanguage: state => {
      return state.curLanguage
    },
    getCurLanguageObj: state => {      
      var targ = state.curLanguage
      var lngSrc = state.languages
      var lang = vue_app.findElementByValue(lngSrc, targ)
      return lang;
    },
    getInterfaceLabels: state => {
      return state.interfaceLabels
    },
    getInterfaceConfigs: state => {
      return state.interfaceConfigs
    },    
    getSearchLanguageList: state => {
      return state.searchLanguageList
    },   
    getOptColorLabels: state => {
      return state.optColorLabels
    },
    getApiJsonTest: state => {
      return state.apiJsonTest
    },
    getEditorialPlaceholders: state => {
      return state.editorialPlaceholders
    },
    getEditorialContents: state => {
      return state.editorialContents
    },    
    getMenuList: state => {
      return state.menuList;
    },
    getLabelGroupList: state => {
      return state.labelGroupList;
    },
    getOptGroupList: state => {
      return state.optGroupList;
    },    
    isCcAdm: state => {
      return state.curApp == 'ccadm'
    },
    isPriceConf: state => {
      return state.curApp == 'price_conf'
    },
    isPackConf: state => {
      return state.curApp == 'pack_conf'
    },
    isSolModel: state => {
      return state.curApp == 'sol_model'
    },
    isSolCampaign: state => {
      return state.curApp == 'sol_campaign'
    },
    isSolDownpayment: state => {
      return state.curApp == 'sol_downpayment'
    },	
    isLanding: state => {
      return state.curApp == 'landing'
    },
	  isFinco: state => {
      return state.curApp == 'finco'
    },				   
    userHasAtLeast2Apps: state => {
      return state.loginSuccess && state.user && (
        (state.user.ccadmEnabled && state.user.priceConfEnabled)||
        (state.user.ccadmEnabled && state.user.packConfEnabled)||
        (state.user.packConfEnabled && state.user.priceConfEnabled)||
        (state.user && state.user.solEnabledFrontEnd)
      )
    },
    authHeader: state => {
      if (state.tokenType && state.accessToken) {
        return {headers: { Authorization: state.tokenType + ' ' + state.accessToken }};
      } else {
        return {};
      }
    },
    uploadCsvJSON: state => state.uploadCsvJSON,
    getStartFromSolModel: state => {
      return state.startFromSolModel
    },
    getStartFromSolCampaign: state => {
      return state.startFromSolCampaign
    },
    getStartFromPriceConf: state => {
      return state.startFromPriceConf
    },
    getComeFromSolModel: state => {
      return state.comeFromSolModel
    },
    getComeFromSolCampaign: state => {
      return state.comeFromSolCampaign
    },
    getComeFromPriceConf: state => {
      return state.comeFromPriceConf
    },
    getBackFromSolModel: state => {
      return state.backFromSolModel
    },
    getBackFromSolCampaign: state => {
      return state.backFromSolCampaign
    },
    getBackFromPriceConf: state => {
      return state.backFromPriceConf
    },
    getBaseUrl: state => {
      return state.baseUrl
    },
    getSolServiceActive: state => {
      return state.solServiceActive
    }
  }
})
